const DEFAULT_LINE_MARGIN = 5;
const DEFAULT_INDENTATION = 11.5;
function computeCuePosition(settings, config) {
  const result = {
    styles: {},
    insertLineBreaks: 0,
    appendLineBreaks: 0
  };
  const textDirection = config?.textDirection ?? "ltr";
  const lineMargin = config?.lineMargin ?? DEFAULT_LINE_MARGIN;
  const { vertical, positionAlign, size } = settings;
  let { snapToLines, line, lineAlign, position, align } = settings;
  let computedLine = getComputedLine(line, snapToLines, lineMargin);
  let computedPositionAlignment = getComputedPositionAlignment(positionAlign ?? "auto", align, textDirection);
  if (snapToLines) {
    snapToLines = false;
    if (computedLine >= 0) {
      line = lineMargin;
      result.insertLineBreaks = computedLine;
    } else {
      line = 100 - lineMargin;
      result.appendLineBreaks = -computedLine - 1;
    }
    computedLine = getComputedLine(line, snapToLines, lineMargin);
  }
  if (lineAlign === void 0 || lineAlign === "start") {
    if (line === 50) {
      lineAlign = "center";
    } else if (line > 50) {
      lineAlign = "end";
    }
  }
  if (config?.defaultToIndentedStartAlignment && position === "auto" && (positionAlign === void 0 || positionAlign === "auto")) {
    const indentation = config?.indentation ?? DEFAULT_INDENTATION;
    switch (computedPositionAlignment) {
      case "line-left":
        position = indentation;
        break;
      case "center":
        position = indentation;
        align = "start";
        break;
      case "line-right":
        position = 100 - indentation;
        break;
    }
    computedPositionAlignment = getComputedPositionAlignment(positionAlign ?? "auto", align, textDirection);
  }
  const computedPosition = getComputedPosition(position, align);
  const writingMode = { "": "horizontal-tb", rl: "vertical-rl", lr: "vertical-lr" }[vertical];
  const maxSize = getMaxSize(computedPosition, computedPositionAlignment);
  const boundSize = Math.min(size, maxSize);
  const width = vertical === "" ? `${boundSize}%` : "auto";
  const height = vertical === "" ? "auto" : `${boundSize}%`;
  const xyPosition = getXYPosition(computedPosition, computedPositionAlignment, boundSize);
  let xPosition;
  let yPosition;
  if (vertical === "") {
    xPosition = xyPosition;
    yPosition = snapToLines ? 0 : computedLine;
  } else {
    xPosition = snapToLines ? 0 : computedLine;
    yPosition = xyPosition;
  }
  const left = `${xPosition}%`;
  const top = `${yPosition}%`;
  let transform = "none";
  if (snapToLines) {
  } else {
    if (vertical === "") {
      if (lineAlign === "center") {
        transform = "translateY(-50%)";
      } else if (lineAlign === "end") {
        transform = "translateY(-100%)";
      }
    } else {
      if (lineAlign === "center") {
        transform = "translateX(-50%)";
      } else if (lineAlign === "end") {
        transform = "translateX(-100%)";
      }
    }
  }
  const textAlign = getTextAlign(align, textDirection);
  result.styles.writingMode = writingMode;
  result.styles.top = top;
  result.styles.left = left;
  result.styles.width = width;
  result.styles.height = height;
  result.styles.transform = transform;
  result.styles.textAlign = textAlign;
  return result;
}
function getMaxSize(computedPosition, computedPositionAlignment) {
  if (computedPositionAlignment === "line-left") {
    return 100 - computedPosition;
  }
  if (computedPositionAlignment === "line-right") {
    return computedPosition;
  }
  if (computedPosition <= 50) {
    return computedPosition * 2;
  }
  return (100 - computedPosition) * 2;
}
function getXYPosition(computedPosition, computedPositionAlignment, size) {
  if (computedPositionAlignment === "line-left") {
    return computedPosition;
  }
  if (computedPositionAlignment === "center") {
    return computedPosition - size / 2;
  }
  return computedPosition - size;
}
function getComputedLine(line, snapToLines, lineMargin) {
  if (line !== "auto") {
    if (!snapToLines && (line < 0 || line > 100)) {
      return 100 - lineMargin;
    }
    return line;
  }
  if (!snapToLines) {
    return 100 - lineMargin;
  }
  return -1;
}
function getComputedPosition(position, align) {
  if (position !== "auto" && position >= 0 && position <= 100) {
    return position;
  }
  switch (align) {
    case "left":
      return 0;
    case "right":
      return 100;
    default:
      return 50;
  }
}
function getComputedPositionAlignment(positionAlign, align, textDirection) {
  if (positionAlign !== "auto") {
    return positionAlign;
  }
  switch (align) {
    case "left":
      return "line-left";
    case "right":
      return "line-right";
    case "start":
      return textDirection === "ltr" ? "line-left" : "line-right";
    case "end":
      return textDirection === "ltr" ? "line-right" : "line-left";
    default:
      return "center";
  }
}
function getTextAlign(align, textDirection) {
  if (align === "start") {
    return textDirection === "ltr" ? "left" : "right";
  }
  if (align === "end") {
    return textDirection === "ltr" ? "right" : "left";
  }
  return align;
}
export {
  computeCuePosition
};
